const state = {
  englishdomStore:
    [
      {
        id: 1,
        title_en: "Conversational English",
        title_ua: "Розмовна англійська",
        title_es: "Inglés conversacional",
        regnumber: "Pre-Intermediate",
        grade_en: "Successfully completed",
        grade_ua: "Успішно завершено",
        grade_es: "Completado con éxito",
        examdate: "18.11.2021",
        image: "https://www.englishdom.com/cn/c100d53f"
      },
      {
        id: 2,
        title_en: "Intermediate level of English",
        title_ua: "Середній рівень англійської мови",
        title_es: "Nivel intermedio de inglés",
        regnumber: "Intermediate",
        grade_en: "Successfully completed",
        grade_ua: "Успішно завершено",
        grade_es: "Completado con éxito",
        examdate: "09.01.2022",
        image: "https://www.englishdom.com/cn/9d6c54e8"
      },
      {
        id: 3,
        title_en: "English for advanced",
        title_ua: "Англійська Поглиблена",
        title_es: "Inglés para avanzados",
        regnumber: "Upper-Intermediate",
        grade_en: "Successfully completed",
        grade_ua: "Успішно завершено",
        grade_es: "Completado con éxito",
        examdate: "14.02.2022",
        image: "https://www.englishdom.com/cn/fbc6541a"
      },
    ]
};
const getters = {};
const mutations = {};
const actions = {};
export default {
  state,
  getters,
  mutations,
  actions
};